"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KaguyaTech = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const Tags_1 = require("../Tags");
const Board_1 = require("../../boards/Board");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const LogHelper_1 = require("../../LogHelper");
const TileType_1 = require("../../TileType");
class KaguyaTech extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.CITY, Tags_1.Tags.PLANT],
            name: CardName_1.CardName.KAGUYA_TECH,
            cost: 10,
            metadata: {
                cardNumber: 'X58',
                description: 'Increase your M€ production 2 steps. Draw 1 card. Remove 1 of your greenery tiles (does not affect oxygen). Place a city there, regardless of other nearby cities. Collect placement bonuses as usual.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.megacredits(2)).cards(1);
                    b.br.br;
                    b.minus().greenery().plus().city();
                }),
            },
        });
    }
    canPlay(player) {
        const greenerySpaces = player.game.board.spaces.filter((space) => Board_1.Board.isGreenerySpace(space) && space.player === player);
        return greenerySpaces.length > 0;
    }
    play(player) {
        const game = player.game;
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        player.drawCard(1);
        const greenerySpaces = game.board.spaces.filter((space) => Board_1.Board.isGreenerySpace(space) && space.player === player);
        return new SelectSpace_1.SelectSpace('Select greenery tile to replace with a city', greenerySpaces, TileType_1.TileType.GREENERY, (space) => {
            player.game.removeTile(space.id);
            LogHelper_1.LogHelper.logBoardTileAction(player, space, 'greenery tile', 'removed');
            player.game.addCityTile(player, space.id, space.spaceType);
            return undefined;
        });
    }
}
exports.KaguyaTech = KaguyaTech;
//# sourceMappingURL=KaguyaTech.js.map